import type {ReactElement} from 'react';
import {useState} from 'react';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import type {EmailMakerReactProps} from '@EmailMakerReact/email-maker-react.types';
import {useEmailMakerContextState} from '@EmailMakerReact/hooks/use-email-maker-context-state';
import {useEmailMakerPublishStateInit} from '@EmailMakerReact/hooks/use-email-maker-publish-state-init';
import {EmailMakerLayout} from '@EmailMakerReact/layout/email-maker-layout/email-maker-layout';
import {EmailMakerMobileControlSheet} from '@EmailMakerReact/components/email-maker-mobile-control-sheet/email-maker-mobile-control-sheet';
import {EmailMakerColumnsAllSheet} from '@EmailMakerReact/components/email-maker-columns-all-sheet/email-maker-columns-all-sheet';
import {EmailMakerColorPickerSheet} from '@EmailMakerReact/components/email-maker-color-picker-sheet/email-maker-color-picker-sheet';
import {EmailMakerBlockSheet} from '@EmailMakerReact/components/email-maker-block-sheet/email-maker-block-sheet';
import {EmailMakerAdminUploadHtmlModal} from '@EmailMakerReact/components/email-maker-admin-upload-html-modal/email-maker-admin-upload-html-modal';
import {EmailMakerAdminImageSourcesModal} from '@EmailMakerReact/components/email-maker-admin-image-sources-modal/email-maker-admin-image-sources-modal';
import {EmailMakerVersionHistorySheet} from '@EmailMakerReact/components/email-maker-version-history-sheet/email-maker-version-history-sheet';

export function EmailMakerReact({store}: EmailMakerReactProps): ReactElement {
  const [canvasContainer, setCanvasContainer] = useState<HTMLElement | null>(null);
  const ctx = useEmailMakerContextState({store, canvasContainer});
  useEmailMakerPublishStateInit(store);

  return (
    <emailMakerContext.Provider value={ctx}>
      <EmailMakerLayout onCanvasContainerReady={setCanvasContainer} />
      <EmailMakerMobileControlSheet />
      <EmailMakerColumnsAllSheet />
      <EmailMakerColorPickerSheet />
      <EmailMakerBlockSheet />
      <EmailMakerVersionHistorySheet />
      {renderAdminModals(store.isSuperUser)}
    </emailMakerContext.Provider>
  );
}

/** Super-user admin dialogs are pre-mounted inside the context so they read the live editor (see README §4). */
function renderAdminModals(isSuperUser: boolean): ReactElement | null {
  if (!isSuperUser) {
    return null;
  }
  return (
    <>
      <EmailMakerAdminUploadHtmlModal />
      <EmailMakerAdminImageSourcesModal />
    </>
  );
}
